/**
 * Hashtags Utility Functions
 *
 * Pure utility functions for hashtags manipulation.
 * These can be safely imported in both client and server code.
 */

import {Keywords} from '__generated__/__types__';

/**
 * Filter valid hashtags that have both tag_name and tag_url
 *
 * @param hashtags - Array of Keywords from server
 * @returns Filtered array with valid hashtags only
 */
export const filterValidHashtags = (hashtags: Keywords[] | undefined | null): Keywords[] => {
    if (!hashtags) return [];
    return hashtags.filter(item => item?.tag_name && item?.tag_url);
};
